import { CalendarConfig, ICalendarsConfigurationData } from '@bciti/types';
import { Observable } from 'rxjs';

export abstract class CalendarService {
    abstract getCalendarConfiguration(orgId: string | number): Observable<CalendarConfig<any>[]>;

    abstract updateCalendarConfiguration(orgId: string | number, config: ICalendarsConfigurationData): Observable<ICalendarsConfigurationData>;
    abstract deleteCalendarConfiguration(orgId: string | number): Observable<any>;
    abstract synchronizeOrgCalendar(orgTag: string): Observable<string>;
}
